import { gql } from "@apollo/client";

export default gql`
  mutation ExportEngagementSurveyToCsvMutation(
    $complianceProgramId: Int!
    $groupBy: EngagementSurveyReportGroupBy!
    $teamIds: [Int]
    $managerIds: [Int]
  ) {
    exportComplianceProgramEngagementSurveyToCsv(
      complianceProgramId: $complianceProgramId
      groupBy: $groupBy
      teamIds: $teamIds
      managerIds: $managerIds
    ) {
      complianceProgram {
        id
      }
    }
  }
`;
